import { Card, CardContent, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
    useForm
} from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { callAPI, IsSmallScreen, Method, updateMainHeader } from "../../../../commonFunctions/CommonFunctions";
import WSAutocompleteField from "../../../../Components/AutoComplete/AutoComplete";
import { HeaderList, IHeaderListActions } from "../../../../Components/Header/HeaderList";
import WSHiddenField from "../../../../Components/HiddenField/WSHiddenField";
import { useSnackbar } from "../../../../Components/Snackbar/SnackBarContext";
import WSTextAreaField from "../../../../Components/WSTextArea/WSTextArea";
import { breadCrumbsStore } from "../../../../Components/BreadCrumbs/BreadCrumbsListner";
export const CreateNotes: React.FC<any> = (props) => {
    const [loading, setLoading] = useState(false);
    const isMobile = IsSmallScreen()
    const { control, register, handleSubmit, setValue, reset } = useForm();
    const { id } = useParams()
    const [loadingSaveAndNew, setLoadingSaveAndNew] = useState(false)
    const { showMessage } = useSnackbar();
    const navigate = useNavigate();
        useEffect(() => {
            updateMainHeader("Add Notes");
            breadCrumbsStore.updateBreadCrumbs([
                { "Notes": "/note/list" },
                { [id ? 'Edit Notes' : "Create Notes"]: `` },
            ]);
        });
    useEffect(() => {
        return () => {
            reset();
        };
    }, []);
    const source = {
        url: "leads/search",
        page: 1,
        pageSize: 10000000,
        filter: [
        ],
        sort: [],
    };
    const transFormData=(data:any)=>{
        const optionLeads:Array<any>=[]
        if(data){
            data.map((item:any)=>{
                optionLeads.push({label:`${item?.firstName} ${item?.lasttName || ""}`,value:item?.id})
            })
       
        }
        return optionLeads;
    }
    useEffect(() => {
        const getNotes = async () => {
            try {
                const response: any = await callAPI(`notes`, Method.GET, null, id);
                if (response && response.data) {
                    setValue('content', response?.data.content)
                    setValue('leadId', response?.data.leadId)
                }
            }
            catch (e) {
            }
        }
        if (id) {
            getNotes();
        }
    }, [id])
    const handleDataSaveAndNew = async (data: any) => {
        try {
            setLoadingSaveAndNew(true)
            const response: any = await saveData(data);
            if (response && response?.message) {

                showMessage(response.message, response.success === true ? 'success' : 'error')
                if (response.success === true) {
                    reset()
                }
            } else if (response?.id) {
                reset()
                showMessage('Deals Created Successfully', 'success')
            }
        } catch (e: any) {
            showMessage(e.error);

        }
        finally {
            setLoadingSaveAndNew(false)
        }
    }
    const handleData = async (data: any) => {
        try {
            setLoading(true)
            const response: any = await saveData(data);
            if (response && response?.message) {
                showMessage(response.message, response.success === true ? 'success' : 'error')
                if (response.success === true) {
                    navigate(`/note/list`)
                }
            } else if (response?.id) {
                showMessage('Note Created Successfully', 'success')
                navigate(`/note/list`)
            }
        } catch (e: any) {
            showMessage(e.error);

        }
        finally {
            setLoading(false)
        }
    }
    const handleCancelClick = () => {
        navigate(`/note/list`)
    }
    const saveData = async (data: any) => {
        const request: any = {
            content: data?.content || "",
            leadId: data.leadId || "",
        }
        if (data?.noteId) {
            const response: any = await callAPI("notes", Method.PUT, request, data.noteId);
            return response
        } else {
            const response: any = await callAPI("notes", Method.POST, request);
            return response
        }

    }
    const actions: IHeaderListActions[] =
        [
            { type: 'button', text: 'Cancel', size: 'small', onClick: handleCancelClick, variant: 'outlined', color: 'primary' },
            { type: 'button', disabled:id!==undefined, text: 'Save & New', loading: loadingSaveAndNew, size: 'small', onClick: handleSubmit(handleDataSaveAndNew), buttonType: 'button', variant: 'outlined', color: 'primary' },
            { type: 'button', text: 'Save', loading: loading, size: 'small', onClick: handleSubmit(handleData), buttonType: 'submit', variant: 'outlined', color: 'primary' }
        ]
    return (
        <Grid >
            <HeaderList title={!id?"Create New Note":"Update Note"} type="card" position="relative" actions={actions} isBackButton={true} url="/note/list" />
            {<Card>
                <CardContent>
                    <form>
                        <Grid container spacing={2} mt={0}>
                            <Grid item xs={12}>
                                <Typography fontWeight={"bold"} sx={{ fontSize: '.9rem' }}>Notes Information</Typography>
                            </Grid>


                            <Grid item xs={12} sm={12}>
                               <WSAutocompleteField
                                    source={source}
                                    rules={{ required: true }}
                                    {...register("leadId")}
                                    id="leadId"
                                    transFormData={transFormData}
                                    isMobile={isMobile}
                                    control={control}
                                    label="Lead"
                                    name="leadId"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <WSTextAreaField
                                    size="small"
                                    label="Add Note"
                                    id="content"
                                    setValue={setValue}
                                    control={control}
                                    {...register("content")}
                                    rules={{ required: true }}
                                    name="content"
                                    rows={4}
                                />
                                <WSHiddenField control={control} name="noteId" defaultValue={id} />
                            </Grid>

                        </Grid >
                    </form>
                </CardContent>
            </Card>
            }
        </Grid >
    );
};

